var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('BaseHero',{attrs:{"resource":_vm.resource,"keep-alive":""}}),_c('BaseTabPanel',{attrs:{"tabs":_vm.tabs,"address-navigation":""}}),_c(_vm.mainComponent,{tag:"component",attrs:{"channel":_vm.resource,"now-playing":_vm.nowPlaying}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }